import PATH_URL from "../../routers/path";

const FULL_ACCESS_ROLES = new Set(["owner", "super admin"]);

export const normalizeRoleName = (profile = {}) =>
  String(profile?.role || profile?.role_name || profile?.nama_role || profile?.roles?.[0]?.name || "")
    .trim()
    .toLowerCase();

export const isFullAccessProfile = (profile) => FULL_ACCESS_ROLES.has(normalizeRoleName(profile));

export const getPermissionSlugs = (profile = {}) =>
  (profile?.permissions || [])
    .map((permission) => (typeof permission === "string" ? permission : permission?.slug))
    .filter(Boolean);

export const hasAnyPermission = (profile, requiredPermissions = []) => {
  if (!requiredPermissions?.length || isFullAccessProfile(profile)) {
    return true;
  }

  const permissionSlugs = new Set(getPermissionSlugs(profile));
  return requiredPermissions.some((permission) => permissionSlugs.has(permission));
};

export const hasAllPermissions = (profile, requiredPermissions = []) => {
  if (!requiredPermissions?.length || isFullAccessProfile(profile)) {
    return true;
  }

  const permissionSlugs = new Set(getPermissionSlugs(profile));
  return requiredPermissions.every((permission) => permissionSlugs.has(permission));
};

export const canProcessSale = (profile, sale) =>
  hasAnyPermission(profile, ["process-sales"]) ||
  (hasAnyPermission(profile, ["process-own-sales"]) &&
    Number(profile?.id) > 0 && Number(sale?.created_by) === Number(profile.id));

export const canEditSale = (profile, sale) =>
  hasAnyPermission(profile, ["edit-sales"]) ||
  (hasAnyPermission(profile, ["edit-own-sales"]) &&
    Number(profile?.id) > 0 && Number(sale?.created_by) === Number(profile.id));

const authorizedLandingPages = [
  { path: PATH_URL.DASHBOARD, permissions: ["view-dashboard"] },
  { path: PATH_URL.POS, permissions: ["view-pos"] },
  { path: PATH_URL.SELLER_STOCK, permissions: ["view-seller-stocks"] },
  { path: PATH_URL.AI_ASSISTANT, permissions: ["view-ai-assistant"] },
  { path: PATH_URL.MATERIAL, permissions: ["view-materials"] },
  { path: PATH_URL.PURCHASE, permissions: ["view-purchases"] },
  { path: PATH_URL.STOCK_OPNAME, permissions: ["view-stock-opnames"] },
  { path: PATH_URL.STOCK_REPORT, permissions: ["view-stock-reports", "view-stock-opnames"] },
  { path: PATH_URL.CASH_BANK, permissions: ["view-cash-bank"] },
  { path: PATH_URL.OPERATIONAL_EXPENSE, permissions: ["view-operational-expenses"] },
  { path: PATH_URL.FIXED_ASSET, permissions: ["view-fixed-assets"] },
  { path: PATH_URL.CUSTOMER, permissions: ["view-customers"] },
  { path: PATH_URL.SALE, permissions: ["view-sales", "view-own-sales"] },
  { path: PATH_URL.REPORT_INCOME, permissions: ["view-reports", "view-sales-reports"] },
];

export const getDefaultAuthorizedPath = (profile) => {
  if (isFullAccessProfile(profile)) {
    return PATH_URL.DASHBOARD;
  }

  return (
    authorizedLandingPages.find(({ permissions }) => hasAnyPermission(profile, permissions))?.path || PATH_URL.PROFILE
  );
};
